import React, { useEffect } from 'react';
import useHouseList from '@root/hooks/useHouseList';
import HouseSelector from '@root/components/HouseSelector';
import MenuSelector from './MenuSelector';
import { isInApp, isIos } from '@root/shared';

const HomeHeader = () => {
  const {
    houses,
    updateTime,
    getHouseList,
    currentHouseId,
    setCurrentHouseId,
  } = useHouseList();

  const inIosApp = isInApp && isIos;

  useEffect(() => {
    // 10m 无需要重复取数据
    if (updateTime && new Date().getTime() - updateTime < 10 * 60 * 1000) {
      return;
    }
    getHouseList();
  }, [getHouseList, updateTime]);

  return (
    <div className="home-header">
      <HouseSelector
        currentHouseId={currentHouseId}
        houseList={houses}
        onSelect={setCurrentHouseId}
      />

      {!inIosApp && <MenuSelector />}
    </div>
  );
};

export default HomeHeader;
